module.exports = __webpack_public_path__ + "img/IRM-mini-NB.7580d4be.png";